import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "main-content" };
const _hoisted_2 = { class: "table-content-wrapper" };
import SubController from '@V/HubAdjustment/Main/SubController.vue';
import HubReportCard from '@V/HubAdjustment/Main/HubReportCard/index.vue';
import Table from '@V/HubAdjustment/Main/HubReportCard/Table.vue';
import { computed } from 'vue';
import { hubMainReportTableHeader } from '@/constants/hubAdjustment';
import vuexStore from '@/vuex-store';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const isVisibleSalesOrderDistributorHubFeeFieldComputed = computed({
            get: () => vuexStore.getters['hubAdjustment/hubMainReport/getterIsSomeSalesOrderDistributorHubFeeAmountExist']
                || vuexStore.getters['hubSelector/getterIsRepresentativeHub'],
            set: () => { },
        });
        const hubMainPurchaseReportItemsComputed = computed({
            get: () => vuexStore.getters['hubAdjustment/hubMainReport/getterMainHubPurchaseReport'],
            set: () => { },
        });
        const hubMainSalesReportItemsComputed = computed({
            get: () => {
                const getterMainHubSalesReport = vuexStore.getters['hubAdjustment/hubMainReport/getterMainHubSalesReport'];
                // [매출 - 허브 수수료 발주 총판 - 로드샵(본사계약)]은 대표허브가 선택되었을 때만 보여주기
                if (!isVisibleSalesOrderDistributorHubFeeFieldComputed.value) {
                    return getterMainHubSalesReport.filter((list, index) => index !== 2);
                }
                return getterMainHubSalesReport;
            },
            set: () => { },
        });
        const hubReportCardInfoList = computed({
            get: () => {
                const result = [
                    [
                        {
                            title: 'sales',
                            headers: hubMainReportTableHeader,
                            items: hubMainSalesReportItemsComputed.value,
                            class: 'mb-4',
                        },
                    ],
                    [
                        {
                            title: 'purchase',
                            headers: hubMainReportTableHeader,
                            items: hubMainPurchaseReportItemsComputed.value,
                        },
                    ],
                ];
                return result;
            },
            set: () => { },
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(SubController),
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hubReportCardInfoList.value, (list, listKey) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: listKey,
                            class: "card-group-wrapper"
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, (info, infoKey) => {
                                return (_openBlock(), _createBlock(HubReportCard, {
                                    key: infoKey,
                                    class: _normalizeClass(info.class),
                                    title: info.title
                                }, {
                                    hubReportTable: _withCtx(() => [
                                        _createVNode(Table, { "card-info": info }, null, 8 /* PROPS */, ["card-info"])
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "title"]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]));
                    }), 128 /* KEYED_FRAGMENT */))
                ])
            ]));
        };
    }
});
